<template>
  <div class="playlet">
    <!-- <el-card class="box-card">
      <div class="selectionArea">
        <div class="item">
          <span class="title">视频名称</span>
          <el-input v-model.trim="parameter.name" clearable placeholder="请输入博主/视频标题" />
        </div>

        <div class="item">
          <span class="title">别名</span>
          <el-input v-model="parameter.alias_name" clearable placeholder="请输入" />
        </div>
        <div class="item">
          <span class="title">视频平台</span>
          <el-select v-model="parameter.type" clearable placeholder="请选择" :style="{ width: '100%' }">
            <el-option
              v-for="item in states"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button size="mini" type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
        </div>
      </div>

    </el-card> -->

    <el-card>
      <el-button
        size="mini"
        type="success"
        icon="el-icon-s-help"
        style="float: right;margin-bottom:10px"
        @click="add"
      >创建</el-button>
      <!-- 主体区 -->
      <div>
        <el-table
          v-loading="loading"
          :data="tableData.list"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="id"
            width="55"
            align="center"
          />
          <el-table-column
            prop="account_name"
            label="小程序名称"
            align="center"
            width="150"
          />
          <el-table-column
            prop="app_id"
            width="200"
            label="app_id"
            align="center"
          />
          <el-table-column
            prop="recommend_all_ad_text"
            label="推荐视频是否全部开启广告"
            align="center"
          >
            <template scope="scope">
              <span>{{ scope.row.recommend_all_ad==2?"开启":'关闭' }}</span>
            </template>

          </el-table-column>
          <el-table-column
            prop="recommend_all_ad_text"
            label="文章是否展示开关"
            align="center"
          >
            <template scope="scope">
              <span>{{ scope.row.open_article==2?"开启":'关闭' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="septal"
            label="间隔弹广告(n到n+1)"
            align="center"
          />
          <el-table-column
            prop="encourage_ad_automatic"
            label="是否自动打开激励广告"
            align="center"
          >
            <template scope="scope">
              <span>{{ scope.row.encourage_ad_automatic==2?"关闭":'开启' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_at_text"
            label="创建时间"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
          >
            <template scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="editrow(scope.row)"
              >修改</el-button>
              <!-- <el-button type="warning" size="small" @click="look(scope.row.id)">预览</el-button>
              <el-button type="primary" size="small" @click="bandtakenotes(scope.row)">绑定记录</el-button> -->
              <el-button
                type="danger"
                size="small"
                @click="myDelete(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column></el-table>
      </div>
      <pagination-right
        :total="tableData.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <el-dialog
        :title="check ? '编辑广告配置' : '创建广告配置'"
        :visible.sync="dialogVisible"
        width="800px"
        :before-close="handleClose"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        :append-to-body="true"
        @close="1"
      >
        <detailList
          ref="add"
          @determine="determine"
        />
      </el-dialog>
    </el-card>
    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="340px"
    >
      <previewdialog ref="timepreview" />
    </el-dialog>
  </div>
</template>

<script>
import previewdialog from './components/previewdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import detailList from './components/detailList.vue'
import { videoAdSettingList, videoSettingDetail, videoAdSettingdlt, videoAdSettinAdd, videoAdSettingUpdate } from '@/api/sourceMaterial.js'
export default {
  name: 'Playlet',
  components: {
    PaginationRight,
    detailList,
    previewdialog
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10,
        name: null,
        alias_name: null,
        type: null,
        mini_program_type: 5
      },
      loading: false,
      states: [
        { id: 1, value: '抖音' },
        { id: 2, value: '快手' }
      ],
      tableData: {
        list: [],
        total: 10
      },
      dialogVisible: false,
      check: undefined,
      priwdialogVisible: false,
      dialogVisiblenotes: false
    }
  },

  created() {
    this.getDatas()
  },
  mounted() {},
  methods: {
    updata() {
      this.dialogVisiblenotes = false
    },
    bandtakenotes(row) {
      this.dialogVisiblenotes = true
      this.$nextTick(() => {
        this.$refs.bandstaffnotesview.send(row)
      })
    },
    async look(id) {
      const data = await videoSettingDetail({
        id
      })
      console.log('data', data.data)
      this.priwdialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(data.data)
      }, 100)
    },

    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.add.reset()
        this.$refs.add.sendr()
      })
    },
    editrow(row) {
      this.check = row
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.add.sendr(row)
      })
    },

    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    async getDatas() {
      // this.loading = true
      const data = await videoAdSettingList(this.parameter)
      this.tableData = data.data
      // this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },

    handleClose() {
      this.check = undefined
      this.dialogVisible = false
    },

    // 删除
    async myDelete(row) {
      this.$confirm('您确定删除吗')
        .then(async() => {
          await videoAdSettingdlt({ id: row.id })
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getDatas()
        })
        .catch(() => {})
    },
    // 提交
    async determine(obj) {
      console.log('obj:', obj)
      try {
        obj.id ? await videoAdSettingUpdate(obj) : await videoAdSettinAdd(obj)
        this.$message({
          message: obj.id ? '修改成功' : '创建成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.$refs.add.reset()
        this.getDatas()
      } catch (error) {
        this.$refs.add.sendr(obj)
      }
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.getDatas()
    },

    // 重置
    reset() {
      this.parameter = {
        name: null,
        alias_name: null,
        type: null,
        page: 1,
        page_size: 10,
        mini_program_type: 4
      }
      this.getDatas()
    },
    close() {
      this.getDatas()
    }
  }
}
</script>

<style scoped>
.playlet {
  margin: 30px;
  width: 95%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(25% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-card {
  height: 70px;
}
</style>

